export interface Department {
  id: number;
  name: string;
  description: string;
  company: string;
  employees: Employee[];
}

export interface DepartmentEmployeePayloadType {
  employee: Employee;
  department: Department;
}

export interface User {
  id: string;
  username: string;
  first_name: string;
  last_name: string;
  email: string;
}

export enum WorkDay {
  MON = 'MON',
  TUE = 'TUE',
  WED = 'WED',
  THU = 'THU',
  FRI = 'FRI',
  SAT = 'SAT',
  SUN = 'SUN',
}

export interface Employee {
  id: string;
  user: User;
  work_days: WorkDay[];
  work_hours_per_day?: moment.Duration;
  company: string;
  departments?: Department[];
  needs_two_factor: boolean;
  dailyBreakTime: number;
}

export type Company = {
  id: string;
  name: string;
  city?: string;
  phoneNumber?: string;
  country?: string;
  bookedUserAmount?: number;
  currentUserAmount?: number;
};
